/**
 * Which sidebar to render. Mode keys on subsystem *nodes in the tree*,
 * not on the permission-filtered extract. A connection with no subsystem
 * nodes — every connection until someone authors one — keeps the
 * pre-subsystems sidebar (full Catalogs/Documents lists). Loading and a
 * failed request count as legacy so a slow or failed fetch degrades to a
 * working sidebar instead of blanking it.
 *
 * Classifier-only trees (`includeInCommandInterface: false`) and
 * empty-after-filter extracts stay in subsystems mode: Dashboard + leftover
 * menus + All functions, no Catalogs/Documents dump.
 */
export function sidebarMode(hasSubsystemNodes: boolean, isLoading: boolean): 'subsystems' | 'legacy' {
  if (isLoading) return 'legacy';
  return hasSubsystemNodes ? 'subsystems' : 'legacy';
}
